import { IconCalendarStats } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { SubcontractorSummaryCaptureBlock as RenderSubcontractorSummaryCaptureBlock } from '../../templateRenderer/CaptureBlocks/SubcontractorSummaryCaptureBlock'
import { SubcontractorSummaryDisplayBlock as RenderSubcontractorSummaryDisplayBlock } from '../../templateRenderer/DisplayBlocks/SubcontractorSummaryDisplayBlock'
import {
  AttendanceValue,
  SubcontractorSummaryCaptureBlock,
  SubcontractorSummaryDisplayBlock,
} from '../../types/blueprint'

import { BaseBlockConfig, Field, TypeOption } from './_BaseBlockConfig'

import { TemplateType } from 'types/api.graphql'

class Config extends BaseBlockConfig<SubcontractorSummaryCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'subcontractorSummary' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Company Summary',
    icon: IconCalendarStats,
    exclusiveTemplateTypes: [TemplateType.SiteDiary],
    helpText: 'Manually set hours per subcontractor',
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: SubcontractorSummaryCaptureBlock,
    value: AttendanceValue
  ): SubcontractorSummaryCaptureBlock {
    const filledAttendances = value?.subcontractorAttendances?.filter(
      (attendance) =>
        attendance.workerAttendance.length > 0 || attendance.comments
    )

    return {
      ...block,
      value: {
        visitors: value?.visitors,
        overrides: [],
        subcontractorAttendances: filledAttendances,
      },
    }
  }

  public override renderBlock(
    block: SubcontractorSummaryCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return (
      <RenderSubcontractorSummaryCaptureBlock block={block} rules={rules} />
    )
  }

  public override renderDisplayBlock(
    block: SubcontractorSummaryDisplayBlock
  ): React.ReactNode {
    return <RenderSubcontractorSummaryDisplayBlock block={block} />
  }
}

export const SubcontractorSummaryCaptureBlockConfig = new Config()
